import {UI} from "../../../../stem-core/src/ui/UIBase";
import {BaseTabAreaStyle, TabArea} from "../../../../stem-core/src/ui/tabs/TabArea";
import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {UserDashboardSubscriptionTab} from "./tabs/UserDashboardSubscriptionTab.jsx";
import {UserDashboardDonationTab} from "./tabs/UserDashboardDonationTab.jsx";
import {UserDashboardNewslettersTab} from "./tabs/UserDashboardNewslettersTab.jsx";
import {UserDashboardAccountTab} from "./tabs/UserDashboardAccountTab.jsx";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {PoweredByBlink} from "../../panel-elements/PoweredByBlink.jsx";
import {isSmallScreen} from "../../../UtilsLib";
import {iFrameState} from "../../../services/IFrameState";
import {PANEL_TYPE} from "../../../../blink-sdk/Constants";
import {BasePanelPage, BasePanelPageStyle} from "../../PanelPage";
import {Flow} from "../../flows/Flow.js";


class TabAreaStyle extends BaseTabAreaStyle {
    @styleRule
    container = {
        border: "1px solid #E5E5E5",
    }

    @styleRuleInherit
    tab = () => ({
        padding: "12px 0",
        cursor: "pointer",
        fontSize: isSmallScreen() ? this.themeProps.FONT_SIZE_SMALL : 18,
        fontWeight: this.themeProps.FONT_WEIGHT_REGULAR,
        flex: 1,
        textAlign: "center",
        border: "none",
        ...this.themeProps.MERCHANT_USER_DASHBOARD_TAB_STYLE,
    });

    @styleRuleInherit
    activeTab = {
        cursor: "default",
        backgroundColor: "",
        ...this.themeProps.MERCHANT_USER_DASHBOARD_ACTIVE_TAB_STYLE,
    };

    @styleRuleInherit
    nav = {
        display: "flex",
    };

    @styleRuleInherit
    tabArea = {
        width: "100%",
        background: this.themeProps.WHITE,
        maxWidth: 540,
        margin: isSmallScreen() ? 0 : "0 auto 12px",
        display: "flex",
        flex: 1,
        overflow: "auto",
        flexDirection: "column",
    };
}

class UserDashboardStyle extends BasePanelPageStyle {
    @styleRuleInherit
    container = {
        height: 780,
        padding: null,
    }

    @styleRuleInherit
    body = {
        flex: 1,
        display: "flex",
        flexDirection: "column"
    }

    @styleRuleInherit
    content = {
        width: 960,
        maxWidth: "100%",
        flex: 1,
        padding: isSmallScreen() ? null : "18px 36px 18px 36px",
    }

    @styleRule
    tabAreaContainer = {
        flex: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%"
    };

    @styleRule
    poweredByBlink = {
        display: isSmallScreen() ? "none" : "",
    }
}

@registerStyle(UserDashboardStyle)
export class UserDashboard extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            hasShadow: false,
        };
    }

    render() {
        const {styleSheet} = this;

        if (!this.tabArea) {
            // Allow multiple aliases to the same tab so we don't have to remember everything
            const tabClasses = {
                [PANEL_TYPE.donation]: UserDashboardDonationTab,
                ["donate"]: UserDashboardDonationTab,
                [PANEL_TYPE.subscribe]: UserDashboardSubscriptionTab,
                ["subscription"]: UserDashboardSubscriptionTab,
                [PANEL_TYPE.newsletter]: UserDashboardNewslettersTab,
                [PANEL_TYPE.auth]: UserDashboardAccountTab,
                ["identity"]: UserDashboardAccountTab,
                ["account"]: UserDashboardAccountTab,
            }

            const tabTypes = Flow.dashboard.getDashboardTabTypes();

            const tabs = tabTypes.map(tabType => {
                const TabClass = tabClasses[tabType];
                if (!TabClass) {
                    const allowedTabTypes = Array.from(Object.keys(tabClasses));
                    console.warn(`Invalid dashboard tab type (${tabType}).\nAllowed types: ${allowedTabTypes}`);
                    return null;
                }
                return <TabClass />;
            });

            // TODO @cleanup why is this cached?
            this.tabArea = <TabArea styleSheet={TabAreaStyle}>
                {tabs}
            </TabArea>;
        }

        return [
            <div className={styleSheet.tabAreaContainer}>
                {this.tabArea}
                <PoweredByBlink className={styleSheet.poweredByBlink}/>
            </div>,
        ];
    }
}
